import React from 'react'
import {motion} from "framer-motion";

const contVariant={
  hidden:{
    opacity:0
  },
  visible:{
    opacity:1,
    scale:1.5,
    transition:{
      duration:0.5,
      yoyo:2
    }
  }
}
export default function PageNotFound() {
	return (
		<motion.div className="container-home" exit={{opacity:0}}
			variants={contVariant}
			initial="hidden"
			animate="visible"
		>
			<div className="page-not-found">
				<h3>Page not found (404)</h3>
				<p>Sorry! the page you are looking for does not exist</p>
			</div>
		</motion.div>
	)
}